import { t } from '@lingui/macro';
import { useLocale } from 'hooks/useLocale';

type PhoneNumberType = {
  phoneNumber: string;
  phoneNumberLink: string;
};
export default function PhoneNumber(isAccountant?: boolean): PhoneNumberType {
  const { isUK } = useLocale();
  const isUkAccountant = isAccountant && isUK;
  const phoneNumber = isUkAccountant ? '020 3778 0324' : t`020 3434 3481`;

  const phoneNumberLink = `${t`+44`}${phoneNumber
    .substring(1)
    .replace(/\s/g, '')}`;

  return {
    phoneNumber,
    phoneNumberLink,
  };
}
